// Quasect logo — "Lock-On" target reticle mark.
// Concept: a sniper crosshair locked on a single point = "we see threats first".
// Catchy, instantly readable as cybersecurity, just 5 SVG primitives — easy to recreate by hand.

export function LogoMark({ size = 32, className = "", variant = "dark" }) {
  // variant: "dark" => cyan ring + neon dot (for dark UI)
  //          "light" => solid black on light backgrounds
  const ring = variant === "dark" ? "#00F0FF" : "#050507";
  const accent = variant === "dark" ? "#39FF14" : "#050507";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Quasect logo"
    >
      {/* Outer reticle ring */}
      <circle cx="32" cy="32" r="22" fill="none" stroke={ring} strokeWidth="3" />

      {/* Crosshair ticks (top/bottom/left/right break through the ring) */}
      <line x1="32" y1="2"  x2="32" y2="16" stroke={ring} strokeWidth="3" strokeLinecap="square" />
      <line x1="32" y1="48" x2="32" y2="62" stroke={ring} strokeWidth="3" strokeLinecap="square" />
      <line x1="2"  y1="32" x2="16" y2="32" stroke={ring} strokeWidth="3" strokeLinecap="square" />
      <line x1="48" y1="32" x2="62" y2="32" stroke={ring} strokeWidth="3" strokeLinecap="square" />

      {/* Locked target — neon green square dot */}
      <rect x="28" y="28" width="8" height="8" fill={accent} />
    </svg>
  );
}

export function LogoLockup({ className = "", variant = "dark", showDot = true, size = 32 }) {
  const textColor = variant === "dark" ? "#FFFFFF" : "#050507";
  const dotColor = "#39FF14";
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} variant={variant} />
      <span
        className="font-display font-black tracking-tighter leading-none"
        style={{
          color: textColor,
          fontFamily: "'Unbounded', sans-serif",
          fontSize: `${Math.round(size * 0.58)}px`,
        }}
      >
        QUASECT
        {showDot && <span style={{ color: dotColor }}>.</span>}
      </span>
    </div>
  );
}

export default LogoLockup;
